import React, { useEffect } from 'react';
import { useStyles } from './Style';
import { Typography, Grid, Button } from '@mui/material';
import { ConfirmDialog, LoadingPage, PaginationComponenets, Icons } from 'components';
import { ActiveDeviceItem, } from './components';
import ActiveDevicesServices from './services/ActiveDevicesServices';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../hooks';
import { getDynamicObjectAction } from 'utility';

const ActiveDevices = () => {
  const classes = useStyles();

  const {
    removing,
    setRemoving,
    openDialog,
    setOpenDialog,
    list,
    setList,
    hasError,
    setHasError,
    currentDevice,
    setCurrentDevice,
    setIsLoading,
    isLoading,
    currentPage, setCurrentPage,
    totalCount, setTotoalCount,
  } = useCustomHook();

  // -- HOOKS --//
  const actionsList =
    getDynamicObjectAction([
      'deviceBusinessBtn',

    ]);
  useEffect(() => {
    if (actionsList['deviceBusinessBtn']) {
      getList();
      paginationOnChange({
        page: currentPage === 0 ? 1 : currentPage,
        pageSize: 5,
        pageNumber: currentPage === 0 ? 0 : currentPage - 1,
        changeData: true,
      });
    }
  }, [currentPage]);


  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
    }
  };

  // -- APIS --//
  const getList = async () => {
    setHasError(false);
    try {
      setIsLoading(true);
      const params = {
        offset: currentPage === 0 ? 0 : ((currentPage - 1) * 12),
        size: 12
      }; // TODO: handle pagination
      const result = await ActiveDevicesServices.getDevices(params);
      const data = result?.result?.devices;
      setIsLoading(false);
      setTotoalCount(result?.result?.total)
      setList(data);
      getCurrentDevice(data);
    } catch (error) {
      setIsLoading(false);

      setHasError(true);
      console.log(error);
    }
  };

  const deleteDevices = async () => {
    setRemoving(true);
    try {
      await ActiveDevicesServices.deleteOtherDevice();
      createToast('موفق', `دیگر دستگاه‌ها با موففقیت خارج شدند`, 'success');

      setRemoving(false);
      setOpenDialog(false);
      getList();
    } catch (error) {
      setRemoving(false);
    }
  };

  const getCurrentDevice = (data) => {
    const res = data.find((v) => v?.current);
    if (res) {
      setCurrentDevice(res);
    }
  };

  const hint =
    'در این بخش کاربر میتواند لیست دستگاه هایی که در آن لاگین است را مشاهده و در صورت تمایل آنها را غیرفعال نماید.';

  return (
    <div>
      <Typography className={classes.hint}>{hint}</Typography>

      {!isLoading && list && list?.length > 0 ? (
        <Grid container justifyContent="space-between" alignItems="center" className={classes.headLine}>
          <Grid item>
            <Typography className={classes.counts}>{list?.length} دستگاه فعال ثبت شده</Typography>
          </Grid>
          <Grid item>

            {list.length === 0 || (list.length === 1 && list[0]?.current) ? null : (
              actionsList['deviceBusinessBtn'] && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.expandBtn}
                  startIcon={<Icons icon="logout" color='#fff' size='18' />}
                  onClick={() => setOpenDialog(true)}
                >
                  خروج از همه دستگاه‌های دیگر
                </Button>
              )
            )}
          </Grid>
        </Grid>
      ) : null}
      {!isLoading && list ? (
        list.length > 0 ? (
          list.map((v, k) =>
            <ActiveDeviceItem key={k} data={v} refreshList={getList} />
          )
        ) : !hasError ? (
          <Typography>لیست دستگاه‌های فعال خالی است!</Typography>
        ) : null
      ) : null}

      {!isLoading && list?.length > 0 ? (
        <Grid justifyContent="center" container style={{ marginTop: 16 }}>
          <PaginationComponenets
            itemsPerPage={12}
            currentPage={currentPage}
            pageCount={totalCount}
            onChange={paginationOnChange}
            removePrePage={true}
          />
        </Grid>
      ) : null}

      {isLoading ? <LoadingPage /> : null}

      {/* Remove All Devices Modal */}
      <ConfirmDialog
        open={openDialog}
        loading={removing}
        onClose={() => setOpenDialog(false)}
        onConfirm={() => deleteDevices()}
        title="تایید خروج از دیگر دستگاه"
        content="آیا از خروج همه دستگاه‌های فعال (به جز دستگاه جاری) اطمینان دارید؟"
        confirmButtonText="خروج دستگاه‌ها"
        cancelButtonProps="انصراف"
      />
    </div>
  );
};

export default ActiveDevices;
